import { IEntityManagerProps, IEntityManagerStates, IInitialData } from "../../components/entityManager/interfaces";
import { IEntity } from "../../components/infrastructure/models";
import { ICity } from "../city/interfaces";
import { IInsurer } from "../insurer/interfaces";
import { IProvince } from "../province/interfaces";

export enum enmPersonalityTypes {
    Actual = 0,
    Legal = 1
}

export const personalityTypesOptions = [
    { title: 'حقیقی', value: enmPersonalityTypes.Actual },
    { title: 'حقوقی', value: enmPersonalityTypes.Legal }
];

export interface ICenterInitialData extends IInitialData {
    Insurers: IInsurer[];
}

export interface IEvaluatorInsurer extends IEntity {
    InsurerId: number;
    EvaluatorId: number;
}

export interface ICenter extends IEntity {
    MainCenterId: number;
    MainCenter: ICenter;
    ParentId?: number;
    Parent?: ICenter;
    IsEvaluator: boolean;
    IsRepairCenter: boolean;
    Code: number;
    Personality: enmPersonalityTypes;
    Name?: string;
    FirstName?: string;
    LastName?: string;
    FullName?: string;
    NationalCode: string;
    ProvinceId: number;
    Province?: IProvince;
    CityId: number;
    City?: ICity;
    Address?: string;
    PostalCode?: string;
    Phone?: string;
    Fax?: string;
    Mobile?: string;
    Email?: string;
    ShebaNo?: string;
    Latitude?: number | null;
    Longitude?: number | null;
    WorkTime?: string;
    IsActive: boolean;
    SecondEvaluationPermission?: boolean;
    EvaluatorInsurers: IEvaluatorInsurer[];
    Insurers: number[];
}

export interface ICenterProps extends IEntityManagerProps<ICenter> {
    isEvaluator: boolean;
    isRepairCenter: boolean;
    params?: () => {
        provinceId?: number;
        cityId?: number;
    };
}

export interface ICenterStates extends IEntityManagerStates<ICenter> {
    insurers: IInsurer[];
}